import React, { MouseEvent, ReactNode } from 'react';
import { StyledMenuLink } from './StyledMenuLink';

type AnchoredLinkProps = {
  anchor: string;
  children: ReactNode;
  onClick?: () => void;
};

export const AnchoredLink = (props: AnchoredLinkProps): JSX.Element => {
  const handleClick = (event: MouseEvent) => {
    event.preventDefault();
    const anchorTarget = document.getElementById(props.anchor);

    if (anchorTarget) {
      anchorTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    if (props.onClick) {
      props.onClick();
    }
  };

  return (
    <StyledMenuLink href={`#${props.anchor}`} onClick={handleClick}>
      {props.children}
    </StyledMenuLink>
  );
};
